import React from 'react';

import { StyledCloseButton, StyledCloseIcon } from './CloseButton-styled-components';

export const CloseButton = ({ onClick }: { onClick: () => void; }) => {
  return (
    <StyledCloseButton onClick={onClick}>
      <StyledCloseIcon />
    </StyledCloseButton>
  );
};
